export default "__VITE_ASSET__b4293369__"